/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'BreadCrumbs',
        import: () => import('@stories/Widgets/Global/BreadCrumbs/BreadCrumbs'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BasicListing',
        import: () => import('@stories/Widgets/BasicListing/BasicListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'InnerHeroBanner',
        import: () => import('@stories/Widgets/InnerHeroBanner/InnerHeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Logos',
        import: () => import('@stories/Widgets/Logos/Logos'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CategoryCards',
        import: () => import('@stories/Widgets/CategoryCards/CategoryCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Usp',
        import: () => import('@stories/Widgets/Usp/Usp'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ProcessCards',
        import: () => import('@stories/Widgets/ProcessCards/ProcessCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FiftyFiftyBanner',
        import: () => import('@stories/Widgets/FiftyFiftyBanner/FiftyFiftyBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AwardDetailBanner',
        import: () => import('@stories/Widgets/AwardDetailBanner/AwardDetailBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Testimonials',
        import: () => import('@stories/Widgets/Testimonials/Testimonials'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AwardLevelCards',
        import: () => import('@stories/Widgets/AwardLevelCards/AwardLevelCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SignUpAwardBanner',
        import: () => import('@stories/Widgets/SignUpAwardBanner/SignUpAwardBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'StandaloneTestimonial',
        import: () => import('@stories/Widgets/StandaloneTestimonial/StandaloneTestimonial'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NewsCaseStudyCardCarousel',
        import: () => import('@stories/Widgets/NewsCaseStudyCardCarousel/NewsCaseStudyCardCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ImageVideo',
        import: () => import('@stories/Widgets/ImageVideo/ImageVideo'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'UspBar',
        import: () => import('@stories/Widgets/UspBar/UspBar'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ResourceListing',
        import: () => import('@stories/Widgets/ResourceListing/ResourceListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NewsCaseStudyListing',
        import: () => import('@stories/Widgets/NewsCaseStudyListing/NewsCaseStudyListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleHeaderBanner',
        import: () => import('@stories/Widgets/ArticleHeaderBanner/ArticleHeaderBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ResourceCarousel',
        import: () => import('@stories/Widgets/ResourceCarousel/ResourceCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HeroBanner',
        import: () => import('@stories/Widgets/HeroBanner/HeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleDetail',
        import: () => import('@stories/Widgets/ArticleDetail/ArticleDetail'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchResults',
        import: () => import('@stories/Widgets/SearchResults/SearchResults'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchInternalBanner',
        import: () => import('@stories/Widgets/SearchInternalBanner/SearchInternalBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'EngageCta',
        import: () => import('@stories/Widgets/EngageCta/EngageCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FAQs',
        import: () => import('@stories/Widgets/Faqs/Faqs'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HelpCentre',
        import: () => import('@stories/Widgets/HelpCentre/HelpCentre'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ResourceDetail',
        import: () => import('@stories/Widgets/ResourceDetail/ResourceDetail'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'UmbracoFormStyles',
        import: () => import('@stories/Components/Misc/Forms/UmbracoForm/UmbracoForm'),
        config: {
            hydrate: 'in-view',
        },
    },
];
